import React from 'react';

const sadam = {
	'sadam.pealkiri': 'Varbla Holiday Village harbour',
	'sadam.blokk1.tutvustus': () => (
		<>
			<h2 className='title is-2'>Harbour</h2>
			<p>
				Varbla Holiday Village has opened a harbour that welcomes all sailors.
			</p>
			<p>
				You can come with a yacht, which draft is up to 2,5m deep and the
				harbour could hold up to 30 boats.
			</p>
			<p>
				The almost 1 kilometer long entrance is safe and peaceful. One side is
				covered with a long pier.
			</p>
			<p>The pier is also really nice for romantic walks.</p>
			<p>
				If you would like to have dinner, drinks or sauna, it is always good to
				know that you are coming.
			</p>
			<p>
				<h3 className='subtitle'>Contacts:</h3>
				<span>+372 53315325 Markus</span>
				<br />
				<span>+372 5061879 Marika</span>
			</p>
			<p>
				<h3 className='subtitle'>State supervision:</h3>
				<span>Maritime security centre +372 6191224</span> <br /> Emergency: 112
			</p>
		</>
	),
	'sadam.blokk1.koordinaadid': () => (
		<>
			<a
				href='https://www.sadamaregister.ee/SadamaRegister/search?nimi=Varbla+Puhkek%C3%BCla+sadam&aadress=&_teenused=on&_ylesanded=on&_veekoguLiigid=on&_veekogud=on'
				target='_blank'
				rel='noopener noreferrer'
			>
				<h2 className='title'>Harbour coordinates:</h2>
			</a>
			<p>North(B): 58° 25′53.00″ N</p>
			<p>East(L): 23° 40′56.00″ E</p>
		</>
	),
	'sadam.hinnakiri.pealkiri': 'Varbla Holiday Village harbour prices for 2020 ',
	'sadam.hinnakiri.lae': 'Download price list',
	'sadam.hinnakiri.tabelAlused': () => (
		<>
			<thead>
				<tr>
					<th colSpan='2'>season 1.May – 31.October</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Boats, who stay for 2 hours</td>
					<td>free</td>
				</tr>
				<tr>
					<td>Boats, length up to 8 meters</td>
					<td>15.-€ / 24h</td>
				</tr>
				<tr>
					<td>Boats, length up to 8 to 10 meters</td>
					<td>20.-€ / 24h</td>
				</tr>
				<tr>
					<td>Boats, length up to 10 to 13 meters</td>
					<td>25.-€ / 24h</td>
				</tr>
				<tr>
					<td>Boats, length up to 13 to 20 meters</td>
					<td>30.-€ / 24h</td>
				</tr>
				<tr>
					<td>Boats, length over 20 meters</td>
					<td>3,50€ a meter / 24h</td>
				</tr>
				<tr>
					<td>Boats, length up to 20 meters 2-8 hours (without stay)</td>
					<td>10.-€</td>
				</tr>
				<tr>
					<td>Boats, length over 20 meters 2-8hours (without stay)</td>
					<td>40.-€</td>
				</tr>
				<tr>
					<td>Slip usage ( in and out)</td>
					<td>8.-€</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<td colSpan='2'>
						<strong>Price includes: </strong>
						Moorage, water, electricity, toilet, shower use up to 4 persons. Car
						parking is not included Safety of the boat is the owners or boat
						users responsibility.
					</td>
				</tr>
			</tfoot>
		</>
	),
	'sadam.hinnakiri.tabelAlusedKodusadam': () => (
		<>
			<thead>
				<tr>
					<th colSpan='3'>
						Long-term price for those, whose home harbour is Varbla harbour
					</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Boats up to 10 meters</td>
					<td>100.-€ month (from June to August)</td>
					<td>50.-€ month</td>
					<td>300.-€ season</td>
				</tr>
				<tr>
					<td>Boats up to 10 - 13 meters</td>
					<td>150.-€ month (from June to August)</td>
					<td>100.-€ month</td>
					<td>450.-€ season</td>
				</tr>
				<tr>
					<td>Boats up to 13 - 20 meters</td>
					<td>200.-€ month (from June to August)</td>
					<td>150.-€ month</td>
					<td>550.-€ season</td>
				</tr>
				<tr>
					<td>Boats over 20 meters</td>
					<td>300.-€ month (from June to August)</td>
					<td>250.-€ month</td>
					<td>750.-€ season</td>
				</tr>
			</tbody>
		</>
	),
	'sadam.hinnakiri.tabelAlusedMitteKodusadam': () => (
		<>
			<thead>
				<tr>
					<th colSpan='3'>
						Long-term price for those, whose home harbour is not Varbla harbour
					</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Boats up to 10 meters</td>
					<td>150.-€ month (from June to August)</td>
					<td>80.-€ month</td>
					<td>400.-€ season</td>
				</tr>
				<tr>
					<td>Boats up to 10 - 13 meters</td>
					<td>200.-€ month (from June to August)</td>
					<td>130.-€ month</td>
					<td>550.-€ season</td>
				</tr>
				<tr>
					<td>Boats up to 13 - 20 meters</td>
					<td>250.-€ month (from June to August)</td>
					<td>180.-€ month</td>
					<td>700.-€ season</td>
				</tr>
				<tr>
					<td>Boats over 20 meters</td>
					<td>350.-€ month (from June to August)</td>
					<td>280.-€ month</td>
					<td>1000.-€ season</td>
				</tr>
			</tbody>
		</>
	),
	'sadam.hinnakiri.tabelHeitmed': () => (
		<>
			<thead>
				<tr>
					<th colSpan='2'>Waste disposal</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Bilge Water from boats</td>
					<td>70.-€ / 1 ton</td>
				</tr>
				<tr>
					<td>Garbage disposal</td>
					<td>25.-€ m3</td>
				</tr>
				<tr>
					<td>Feces disposal</td>
					<td>20.-€ / 1 ton</td>
				</tr>
			</tbody>
		</>
	),
	'sadam.hinnakiri.tabelParkimine': () => (
		<>
			<thead>
				<tr>
					<th colSpan='3'>Parking in the harbours parkinglot</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Car</td>
					<td>2.-€ day</td>
					<td>20.-€ month</td>
				</tr>
				<tr>
					<td>Car trailer</td>
					<td>2.-€ day</td>
					<td>20.-€ month</td>
				</tr>
				<tr>
					<td>Bus or truck</td>
					<td>4.-€ day</td>
					<td>40.-€ month</td>
				</tr>
			</tbody>
		</>
	),
	'sadam.hinnakiri.tabelLisatasu': () => (
		<>
			<thead>
				<tr>
					<th colSpan='2'>For extra fee</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Laundry</td>
					<td>4.-€ / load</td>
				</tr>
				<tr>
					<td>Shower</td>
					<td>3€ /person</td>
				</tr>
				<tr>
					<td>Sauna</td>
					<td>30€ / hour</td>
				</tr>
				<tr>
					<td>Towel rent</td>
					<td>2€ per</td>
				</tr>
				<tr>
					<td>Camping</td>
					<td>3.-€ /person</td>
				</tr>
				<tr>
					<td>Bike rent</td>
					<td>2.-€ /hour, 10.-€ /day</td>
				</tr>
				<tr>
					<td>Boat rent</td>
					<td>7.-€ /hour, 30.-€ /day</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<td colSpan='2'>All the prices include taxes.</td>
				</tr>
			</tfoot>
		</>
	),
};

export default sadam;
